import { render } from "./PhotoUploadArea.vue?vue&type=template&id=7b04aac1&scoped=true"
import script from "./PhotoUploadArea.vue?vue&type=script&lang=js"
export * from "./PhotoUploadArea.vue?vue&type=script&lang=js"

import "./photo-upload-area.scss?vue&type=style&index=0&id=7b04aac1&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b04aac1"]])

export default __exports__